import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { buildPageList } from "./dashboardViewModel";

interface PagerProps {
  page: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export function Pager({ page, pageSize, totalItems, onPageChange }: PagerProps) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const start = totalItems === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pt-3">
      <span className="mulish text-xs tabular-nums text-text-muted">
        Showing {start}–{end} of {totalItems}
      </span>
      {totalPages > 1 && (
        <div className="flex items-center gap-1.5">
          <Button
            variant="outline"
            size="sm"
            className={cn(
              "relative h-9 rounded-lg px-3 tap-target",
              // A disabled control has nothing to sit on.
              page > 1 && "bg-surface dark:bg-surface",
            )}
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            Previous
          </Button>
          {buildPageList(page, totalPages).map((item, i) =>
            item === "ellipsis" ? (
              <span key={`ellipsis-${i}`} className="px-1 text-text-faint">
                …
              </span>
            ) : (
              <Button
                key={item}
                variant={item === page ? "default" : "outline"}
                size="sm"
                className={cn(
                  "relative size-9 rounded-lg p-0 tabular-nums tap-target",
                  item !== page && "bg-surface dark:bg-surface",
                )}
                onClick={() => onPageChange(item)}
              >
                {item}
              </Button>
            ),
          )}
          <Button
            variant="outline"
            size="sm"
            className={cn(
              "relative h-9 rounded-lg px-3 tap-target",
              page < totalPages && "bg-surface dark:bg-surface",
            )}
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
}
